module.exports = __webpack_public_path__ + "img/trashbin.a021ea71.svg";